const nombreGrupo = (valor, alternativo) => String(valor || '').trim() || alternativo;

const claveGrupo = (id, nombre) => id != null && id !== ''
  ? String(id)
  : `nombre:${nombre.toLocaleLowerCase('es')}`;

const ordenarPorNombre = (a, b) => a.nombre.localeCompare(b.nombre, 'es', { sensitivity: 'base' });

function agregarFila(grupo, item) {
  grupo.filas.push(item);
  grupo.presupuesto += Number(item.fila.Presupuesto) || 0;
  grupo.venta += Number(item.fila.Venta) || 0;
}

// Conserva la fila original del SP: no vuelve a sumar métricas ni duplica vendedores.
export function agruparVendedores(filas, incluirSupervisores) {
  const grupos = new Map();

  filas.forEach((fila, indice) => {
    const item = { fila, indice };
    const nombreSupervisor = nombreGrupo(fila.Supervisor, 'Sin supervisor asignado');
    const nombreBodega = nombreGrupo(fila.Bodega, 'Sin bodega asignada');
    const supervisorId = claveGrupo(fila.idSupervisor, nombreSupervisor);
    const bodegaId = claveGrupo(fila.idBodega, nombreBodega);
    const clavePrincipal = incluirSupervisores ? `supervisor:${supervisorId}` : `bodega:${bodegaId}`;

    if (!grupos.has(clavePrincipal)) {
      grupos.set(clavePrincipal, {
        clave: clavePrincipal,
        tipo: incluirSupervisores ? 'supervisor' : 'bodega',
        nombre: incluirSupervisores ? nombreSupervisor : nombreBodega,
        filas: [],
        presupuesto: 0,
        venta: 0,
        bodegas: new Map(),
      });
    }

    const grupo = grupos.get(clavePrincipal);
    agregarFila(grupo, item);

    if (incluirSupervisores) {
      if (!grupo.bodegas.has(bodegaId)) {
        grupo.bodegas.set(bodegaId, {
          clave: `${clavePrincipal}:bodega:${bodegaId}`,
          tipo: 'bodega',
          nombre: nombreBodega,
          filas: [],
          presupuesto: 0,
          venta: 0,
        });
      }
      agregarFila(grupo.bodegas.get(bodegaId), item);
    }
  });

  return [...grupos.values()].sort(ordenarPorNombre).map(grupo => ({
    ...grupo,
    bodegas: [...grupo.bodegas.values()].sort(ordenarPorNombre),
  }));
}

export function obtenerFilasVisibles(grupos, incluirSupervisores, expandidos, periodo) {
  const visibles = [];
  grupos.forEach(grupo => {
    visibles.push({ tipo: 'grupo', grupo, nivel: incluirSupervisores ? 0 : 1 });
    if (!expandidos[`${periodo}:${grupo.clave}`]) return;

    if (incluirSupervisores) {
      grupo.bodegas.forEach(bodega => {
        visibles.push({ tipo: 'grupo', grupo: bodega, nivel: 1 });
        if (expandidos[`${periodo}:${bodega.clave}`]) {
          bodega.filas.forEach(item => visibles.push({ tipo: 'vendedor', ...item }));
        }
      });
    } else {
      grupo.filas.forEach(item => visibles.push({ tipo: 'vendedor', ...item }));
    }
  });
  return visibles;
}
